import Attribute from './Attribute';
import EnumAttribute from './EnumAttribute';
import RefAttribute from './RefAttribute';
import MultiRefAttribute from './MultiRefAttribute';
import RemoteRefAttribute from './RemoteRefAttribute';
import CalculatedAttribute from './CalculatedAttribute';
import ObjectAttribute from './ObjectAttribute';
import Entity from "./Entity";

class EntityType {

    constructor(definition) {
        this.name = definition.name;
        this.label = definition.label;
        this.titleAttributes = ['id'];
        this.attributes = this.parseAttributes(definition.attributes);
    }

    createEntity(data, prefill = false) {
        if (data === null)
            return null;
        return new Entity(this, this.fromJson(data, prefill));
    }

    fromJson(data, prefill = false) {
        const res = {};
        for (const [attributeId, attribute] of Object.entries(this.attributes)) {
            if (data) {
                res[attributeId] = attribute.fromJson(data[attributeId]);
            }
            if (!res[attributeId] && prefill && attribute.prefillExpression) {
                res[attributeId] = attribute.fromJson(eval(attribute.prefillExpression));
            }
        }
        return res;
    }

    toJson(values) {
        const res = {};
        for (const [attributeId, attribute] of Object.entries(this.attributes)) {
            if (attribute.type === 'remoteref' || attribute.type === 'calculated') {
                continue;
            }
            res[attributeId] = attribute.toJson(values[attributeId]);
        }
        return res;
    }

    getName() {
        return this.name;
    }

    getAttributes() {
        return Object.keys(this.attributes).map(attributeId => this.getAttribute(attributeId))
    }

    getAttribute(attributeId) {
        return this.attributes[attributeId];
    }

    parseAttributes(attributeDefinitions) {
        let attributes = {};
        for (let attributeId in attributeDefinitions) {
            let attribute = attributeDefinitions[attributeId];
            const  attr = this.parseAttribute(attributeId, attribute);
            attributes[attributeId] = attr;
            if (attr.titleOrder) {
                this.titleAttributes[attr.titleOrder-1] = attributeId;
            }
        }
        return attributes;
    }

    parseAttribute(attributeId, def) {
        let attr;
        let type = def.type;
        if (typeof type === 'object') {
            type = type.name;
        }

        switch (type) {
            case 'enum':
                attr = new EnumAttribute(attributeId, def);
                break;
            case 'ref':
                attr =  new RefAttribute(attributeId, def);
                break;
            case 'multiref':
                attr =  new MultiRefAttribute(attributeId, def);
                break;
            case 'remoteref':
                attr =  new RemoteRefAttribute(attributeId, def);
                break;
            case 'calculated':
                attr =  new CalculatedAttribute(attributeId, def);
                break;
            case 'object':
                attr =  new ObjectAttribute(attributeId, def);
                break;
            default:
                attr =  new Attribute(attributeId, def);
        }
        attr.titleOrder = def.hasOwnProperty('titleOrder') ? def.titleOrder : null;
        return attr;
    }

    getTitle(entity) {
        let title = '';
        this.titleAttributes.forEach(a =>  {
            if (title) {
                title += ' ';
            }
            title += entity[a];
        });
        return title;
    }

    createEntities(list) {
        return list.map(entity => {
            return this.createEntity(entity);
        })
    }
}

export default EntityType;